import { NextSeo } from "next-seo";
import { Post, Page, Service, Job, Specialty } from "client";
export interface AllPostTypeProps {
	page:
	| Post
	| Post["preview"]["node"]
	| Page
	| Page["preview"]["node"]
	| Service
	| Service["preview"]["node"]
	| Specialty
	| Specialty["preview"]["node"]
	| Job
	| Job["preview"]["node"]
	| null
	| undefined;
}

const useSEO = ({ page }: AllPostTypeProps) => {
	const ogTitle = page?.seo?.opengraphTitle || page?.seo?.title || "";
	const ogDescription = page?.seo?.opengraphDescription || page?.seo?.metaDesc || "";

	const OGImages = [];

	if (page?.seo?.opengraphImage?.sourceUrl()) {
		OGImages.push({
			url: page?.seo?.opengraphImage?.sourceUrl(),
			width: page?.seo?.opengraphImage?.mediaDetails?.width,
			height: page?.seo?.opengraphImage?.mediaDetails?.height,
			alt: page?.seo?.opengraphImage?.altText,
		});
	}

	OGImages.push({
		url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/images/crafted-office-background.jpg`,
		width: 1200,
		height: 630,
		alt: page?.seo?.title || "Crafted",
	});

	return (
		<NextSeo
			title={page?.seo?.title}
			description={page?.seo?.metaDesc}
			canonical={page?.seo?.opengraphUrl}
			noindex={page?.seo?.metaRobotsNoindex === "noindex"}
			nofollow={page?.seo?.metaRobotsNofollow === "nofollow"}
			openGraph={{
				type: "website",
				locale: "en_US",
				url: page?.seo?.opengraphUrl,
				title: ogTitle || undefined,
				description: ogDescription || undefined,
				images: OGImages,
			}}
			twitter={{
				site: "@crafteduiux",
				cardType: "summary_large_image",
			}}
		/>
	);
};

export default useSEO;
